// src/components/WhyBhutanComponent.vue
<template>
    <section class="py-16 px-4 bg-gray-50">
        <div class="max-w-6xl mx-auto">
            <h2 class="text-4xl font-bold text-bhutan-green mb-6 animate-fadeIn">{{ heading }}</h2>
            <p class="text-lg mb-12 animate-fadeIn animation-delay-200">
                {{ paragraph }}
            </p>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div v-for="card in investmentCards" :key="card.id"
                    class="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:scale-105">
                    <img :src="card.image" :alt="card.title" class="w-full h-48 object-cover" />
                    <div class="p-4">
                        <h4 class="text-lg font-semibold mb-2">{{ card.title }}</h4>
                        <p class="text-sm mb-4">{{ card.excerpt }}</p>
                        <!-- <a href="#" class="text-bhutan-green hover:underline">Read more</a> -->
                    </div>
                </div>
            </div>
            <div class="text-center mt-8">
                <router-link to="/why-bhutan">
                    <button @click="$emit('show-more')"
                    class="bg-bhutan-green text-white px-6 py-2 rounded-full hover:bg-bhutan-green-light transition-colors transform hover:scale-105">
                    Learn More About Investing in Bhutan
                </button>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">

interface InvestmentCard {
    id: number;
    title: string;
    excerpt: string;
    image: string;
}

defineProps<{
    heading: string;
    paragraph: string;
    investmentCards: InvestmentCard[];
}>()

defineEmits(['show-more'])
</script>

<style scoped>
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fadeIn {
    animation: fadeIn 0.5s ease-out forwards;
}

.animation-delay-200 {
    animation-delay: 0.2s;
}

.animation-delay-400 {
    animation-delay: 0.4s;
}
</style>
